export default __webpack_public_path__ + "static/media/dedicske.2740403e.jpg";